(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trd-seo-page"] && !Shopify.designMode) return;
  try {
    
  function trdReplaceHeading(element, tagName) {
    const replacement = document.createElement(tagName);
    for (const attribute of element.attributes) replacement.setAttribute(attribute.name, attribute.value);
    while (element.firstChild) replacement.appendChild(element.firstChild);
    element.replaceWith(replacement);
    return replacement;
  }

  function trdSlug(value) {
    return value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 64);
  }

  function trdMakeAccordion(heading) {
    if (!heading.parentElement || heading.closest('details')) return;
    const level = Number(heading.tagName.slice(1));
    const details = document.createElement('details');
    details.className = 'trd-auto-accordion';
    const summary = document.createElement('summary');
    summary.innerHTML = heading.innerHTML;
    const panel = document.createElement('div');
    panel.className = 'trd-auto-accordion__panel';
    heading.parentElement.insertBefore(details, heading);
    details.append(summary, panel);
    let sibling = heading.nextSibling;
    heading.remove();
    while (sibling) {
      const next = sibling.nextSibling;
      if (sibling.nodeType === Node.ELEMENT_NODE && /^H[1-6]$/.test(sibling.tagName)) {
        const siblingLevel = Number(sibling.tagName.slice(1));
        if (siblingLevel <= level) break;
      }
      panel.appendChild(sibling);
      sibling = next;
    }
  }

  function trdOrganizePage(root) {
    if (root.dataset.trdReady === 'true') return;
    root.dataset.trdReady = 'true';
    const content = root.querySelector('[data-trd-content]');
    if (!content) return;

    content.querySelectorAll('h1').forEach((heading) => trdReplaceHeading(heading, 'h2'));
    content.querySelectorAll('h2,h3,h4,h5,h6').forEach((heading) => {
      const label = heading.textContent.replace(/\u00a0/g, ' ').trim();
      if (!label) heading.remove();
    });
    const handle = root.dataset.pageHandle || '';
    const initialHeadings = [...content.querySelectorAll('h2,h3')];
    const isFaqPage = handle === 'faq';
    const isLegalPage = root.classList.contains('trd-page--legal');
    const questionPattern = /^(what|who|why|when|where|which|how|can|do|does|did|is|are|will|would|should|could)\b/i;
    const detailPattern = /^(week|month|phase|pillar|step|case study|testimonial|“|\d+[.)])\b/i;

    if (!isLegalPage) {
      const majorHeadings = initialHeadings.filter((heading) => heading.tagName === 'H2');
      const keepMajorSectionsOpen = isFaqPage ? 2 : 4;
      if (majorHeadings.length > 12) {
        majorHeadings.forEach((heading, index) => {
          if (index >= keepMajorSectionsOpen) trdMakeAccordion(heading);
        });
      }
    }

    initialHeadings.forEach((heading, index) => {
      if (heading.closest('details')) return;
      const text = heading.textContent.trim();
      const isQuestion = text.endsWith('?') || questionPattern.test(text);
      const isDetail = detailPattern.test(text);
      const faqDetail = isFaqPage && heading.tagName === 'H3';
      const longPageDetail = initialHeadings.length > 18 && index > 4 && heading.tagName === 'H3';
      if (isQuestion || isDetail || faqDetail || longPageDetail) trdMakeAccordion(heading);
    });

    const toc = root.querySelector('[data-trd-toc]');
    if (toc) {
      const tocHeadings = [...content.querySelectorAll('h2')].filter((heading) => !heading.closest('details')).slice(0, 10);
      tocHeadings.forEach((heading, index) => {
        if (!heading.id) heading.id = `section-${trdSlug(heading.textContent) || index + 1}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        toc.appendChild(link);
      });
      if (!toc.children.length) root.querySelector('.trd-page-toc')?.remove();
    }
  }

  document.querySelectorAll('[data-trd-organize]').forEach(trdOrganizePage);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-trd-organize]').forEach(trdOrganizePage);
  });

  } catch(e) { console.error(e); }
})();
})();
